import { Layout, LayoutColumn } from '@kiwicom/orbit-components';
import styled from 'styled-components';

const ContentWrapper = styled.div`
  margin-top: ${({ theme }) => theme.orbit.spaceLarge};
`;

type LayoutWrapperProps = {
  extraPaddingBottom: number;
  maxWidth: string;
};

const LayoutWrapper = styled.div<LayoutWrapperProps>`
  & > :first-child {
    ${({ maxWidth }) => (maxWidth != null ? `max-width:${maxWidth};` : '')}
    padding-bottom: ${({ extraPaddingBottom }) => 64 + extraPaddingBottom}px;
    display: block;
  }
`;
type Props = {
  readonly children: JSX.Element | JSX.Element[];
  readonly maxWidth?: string;
  readonly extraPaddingBottom?: number;
};

const AccountLayout = ({ children, maxWidth, extraPaddingBottom = 0 }: Props): JSX.Element => {
  return (
    <LayoutWrapper extraPaddingBottom={extraPaddingBottom} maxWidth={maxWidth}>
      <Layout type="MMB">
        <LayoutColumn>
          <ContentWrapper>{children}</ContentWrapper>
        </LayoutColumn>
      </Layout>
    </LayoutWrapper>
  );
};

export default AccountLayout;
